export class FlightInfo {
  airlineCode: string;
  flightNumber: string;
}
